/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/Menu',['pixi', 'absolute', 'lodash', 'Managers/ScaleManager'],
/**
 * @param Absolute { import("./code/dependencies/absolute/absolute.js") }
 */
	function (PIXI, Absolute, _, ScaleManager) {

		var Menu = function (config) {

			this._currentLayoutType = 'xl';

			var defaultConfig = {
				tiles: [],
				label: '',
				letterStyle: {
					font: Absolute.ScreenMetrics.getResScale() * 45 + 'px Arial',
					fontFamily: 'segoe',
					fill: '#ffffff',
					tint: 0xffffff,
					align: 'left'
				},
				tilePaddingX: Absolute.Coords.x(24),
				tilePaddingY: Absolute.Coords.x(50)
			};
			this.initMenu(_.extend(defaultConfig, config));
		};

		Menu.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

		Menu.prototype.initMenu = function (config, pageGeneratorConfig) {

			PIXI.DisplayObjectContainer.call(this);
			this.container = new PIXI.DisplayObjectContainer();

			this.config = config;
			var layoutConfig = this.getLayoutConfig();

			this.pageGenerator = new Absolute.MultiPageGenerator({
				width: this.config.width ? this.config.width : Absolute.Coords.x(1920),
				height: Absolute.Coords.y(1080),
				cardScale: this.config.scale || 1,
				padding: {'x': this.config.tilePaddingX, 'y': this.config.tilePaddingY},
				itemWidth: this.config.tiles[0].width,
				itemHeight: this.config.tiles[0].height,
				align: this.config.align || 'none',
				maxWidth: this.config.maxWidth,
				keepOneLine: this.config.keepOneLine,
				startY: this.config.startY || 0
			});

			this.configTiles = this.config.tiles.slice();

			this.checkAndAddTransparentElements();

			this.pages = this.pageGenerator.getPages(this.configTiles);
			_.each(this.pages, function (page) {
				this.container.addChild(page);
			}, this);

			// label
			if (this.config.label !== '') {
				var labelKey = 'menu.' + this.config.label;
				var labelString = Absolute.StringManager(labelKey);
				if (labelString === labelKey) {
					labelString = this.config.label;
				}
				this.label = new PIXI.Text(labelString, this.config.letterStyle);
				if (this.config.labelPosition) {
					this.label.x = this.config.labelPosition.x;
					this.label.y = this.config.labelPosition.y;
				} else {
					this.label.x = -Absolute.Coords.x(27);
					this.label.y = -Absolute.Coords.y(70);
				}
				this.label.scale.set(this.pageGenerator.cardScale);
				this.container.addChildAt(this.label, 0);
			}
			ScaleManager.addElement(this, {scaleChangeSource: 'Full'});
			this.addChild(this.container);

			this.currentHeight = this.height;
			this.handleResize();
		};

		Menu.prototype.checkAndAddTransparentElements = function () {
			if (this.config.keepOneLine) {
				var count = (this.config.tilesInOneLine || (this.config.maxColNum ? this.config.maxColNum : 5)) - this.config.tiles.length;
				if (count > 0) {
					var tileExample = this.config.tiles[0];
					for (var i = 0; i < count; i++) {
						var tileMock = new PIXI.Graphics();
						tileMock.beginFill(0xffa500, 0);
						tileMock.drawRect(0, 0, tileExample.width, tileExample.height);
						tileMock.endFill();
						this.configTiles.push(tileMock);
					}
				}
			}
		};

		Menu.prototype.onShow = function () {
			_.each(this.config.tiles, function (item) {
				if (typeof item.onShow === 'function') {
					item.onShow();
				}
			});
			this.handleResize();
		};

		Menu.prototype.onHide = function () {
			_.each(this.config.tiles, function (item) {
				if (typeof item.onHide === 'function') {
					item.onHide();
				}
			})
		};

		Menu.prototype.handleResize = function () {
			if (!this.currentHeight) return;
			var layoutConfig = this.getLayoutConfig();
			this.updateLayout(layoutConfig);
			this.currentHeight = this.height;
		};

		Menu.prototype.updateLayout = function (layoutConfig) {
			if (layoutConfig.type === this._currentLayoutType) return;
			var pageGeneratorConfig = _.extend({}, this.pageGenerator.settings);
			pageGeneratorConfig.align = layoutConfig.align;
			pageGeneratorConfig.maxWidth = Absolute.Coords.x(layoutConfig.maxWidth);
			pageGeneratorConfig.maxHeight = Absolute.Coords.y(layoutConfig.maxHeight);
			this.pages.forEach(function (page) {
				if (this.container.children.indexOf(page) !== -1) {
					this.container.removeChild(page);
				}
			}.bind(this));
			this.pageGenerator.updateSettings(pageGeneratorConfig);
			this.pages = this.pageGenerator.getPages(this.configTiles);
			this.pages.forEach(function (p) {
				this.container.addChild(p)
			}.bind(this));
			this._currentLayoutType = layoutConfig.type;
		};

		Menu.prototype.getLayoutConfig = function () {
			//set as default
			var layoutConfig = {
				"screenHeight": 1920,
				"screenWidth": 1080,
				"align": "none",
				"type": "xl",
				"maxWidth": 1875
			}
			for (var i = 0; i < this.config.layoutConfigs.length; i++) {
				if ((this.config.layoutConfigs[i].screenHeight && ScaleManager.height < this.config.layoutConfigs[i].screenHeight) ||
					(this.config.layoutConfigs[i].screenWidth && ScaleManager.width < this.config.layoutConfigs[i].screenWidth)) {
					layoutConfig = this.config.layoutConfigs[i];
				}
			}
			return layoutConfig;
		};

		Menu.prototype.addTooltip = function (tooltip) {
			this.addChild(tooltip);
		};

		Menu.prototype.removeTooltip = function (tooltip) {
			this.removeChild(tooltip);
		};

		return Menu;

	});

